import { UNIT_SYSTEM } from '../../../../../shared/config/hydraulics_constants';
import { CONTROL_TABLE_PARAMETER_MAP, DATAGRID_TABLE_CELL_WIDTH } from '../../../../../utils/constants';

const columns = (renderNameCell, renderValueCell, renderActions, units, currentUnit) => [
  {
    field: 'priority',
    headerName: 'Priority',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    editable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'maintain',
    headerName: 'Maintain',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderNameCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'parameter',
    headerName: 'Parameter',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderNameCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }

      const getLabelKey = data => CONTROL_TABLE_PARAMETER_MAP[data] || null;

      const value = params.value;
      const labelKey = getLabelKey(value);

      return `${value} (${units[labelKey]?.label})`;
    },
  },
  {
    field: 'from',
    headerName: 'From',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      const parameter = params.row?.parameter;
      const labelKey = CONTROL_TABLE_PARAMETER_MAP[parameter];
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(units[labelKey]?.decimals));
    },
  },
  {
    field: 'to',
    headerName: 'To',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      const parameter = params.row?.parameter;
      const labelKey = CONTROL_TABLE_PARAMETER_MAP[parameter];
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(units[labelKey]?.decimals));
    },
  },
  {
    field: 'step_size',
    headerName: 'Step Size',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      const parameter = params.row?.parameter;
      const labelKey = CONTROL_TABLE_PARAMETER_MAP[parameter];
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(units[labelKey]?.decimals));
    },
  },
  {
    field: 'actions',
    headerName: 'Actions',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    headerAlign: 'center',
    align: 'center',
    renderCell: renderActions,
  }
];
export default columns;
